var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4304 11.0545C35.7519 28.6569 25.2522 36.1453 19.299 37.912C18.9046 38.0293 18.4847 38.0293 18.0903 37.912C12.2349 36.1762 2.036 28.9089 2 11.9314C2.03527 10.4643 2.8604 9.13071 4.15755 8.44436C13.2198 3.32693 17.5786 2 18.6869 2C19.7953 2 24.4987 3.41179 34.1626 8.94324C34.9278 9.37441 35.4094 10.1765 35.4304 11.0545Z",
    stroke: "white",
    strokeWidth: 3.85736,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 20.0397L16.1436 25.1828L26.4299 14.876",
    stroke: "white",
    strokeWidth: 3.85736,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.5de64b54c1d107c5300b43cb0a4103a4.svg";
export { ForwardRef as ReactComponent };